





import Vue from 'vue'
export default Vue.extend({
  name: 'BrandLogo',
  props: {
    brand: {
      type: String,
    },
  },
  computed: {
    computedBrand(): string {
      return this.brand.toLowerCase()
    },
    src(): string {
      try {
        return require(`../assets/images/logos/${this.computedBrand}-logo.svg`)
      } catch (e) {
        return ''
      }
    },
  },
})
